var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb10" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "numberSearch", attrs: { label: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.type1,
                                    callback: function ($$v) {
                                      _vm.type1 = $$v
                                    },
                                    expression: "type1",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.InvoiceSecretKey"
                                      ),
                                      value: "invoiceKeyList",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "GlobalSetObj.waybillNumber"
                                      ),
                                      value: "waybillNumbers",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "receivablePayable.TicketNumber"
                                      ),
                                      value: "businessNumberList",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.InvoiceNumber"),
                                      value: "invoiceNumberList",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("InputTextareaCmp", {
                            ref: "inputTextareaRef",
                            attrs: {
                              val: _vm.listVal,
                              "max-length": 2000,
                              "min-rows": 5,
                            },
                            on: {
                              input: function (_, val) {
                                return (_vm.listVal = val)
                              },
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.InvoicingTime"),
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "datetimerange",
                                      "range-separator": "-",
                                      "picker-options": _vm.pickerOptions,
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      "default-time": ["00:00:00", "23:59:59"],
                                      "start-placeholder": _vm.$t(
                                        "GlobalSetObj.startDate"
                                      ),
                                      "end-placeholder": _vm.$t(
                                        "GlobalSetObj.endDate"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.invoiceIssueTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "invoiceIssueTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.invoiceIssueTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.businessT"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.businessType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "businessType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.businessType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.tudo"
                                          ),
                                          value: null,
                                        },
                                      }),
                                      _vm._l(
                                        _vm.BUSINESS_TYPE,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("basicData.InvoiceStatus"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "collectionCenter.tudo"
                                        ),
                                        multiple: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.statusList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "statusList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.statusList",
                                      },
                                    },
                                    _vm._l(_vm.INVOICE_STATUS, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.client"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        "remote-method": _vm.getCustomerPage,
                                        clearable: "",
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        multiple: "",
                                        "collapse-tags": "",
                                      },
                                      on: {
                                        "visible-change": function ($event) {
                                          return _vm.getCustomerPage()
                                        },
                                      },
                                      model: {
                                        value: _vm.queryForm.params.customerIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "customerIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.customerIds",
                                      },
                                    },
                                    _vm._l(_vm.customerList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label:
                                            item.customerAlias +
                                            "（" +
                                            item.username +
                                            "）",
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "orderCenterCont.PackageType"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.orderPackageType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "orderPackageType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.orderPackageType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t("GlobalSetObj.all"),
                                          value: null,
                                        },
                                      }),
                                      _vm._l(
                                        _vm.ParcelType,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("placeOrder.cargoType"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.cargoType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "cargoType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.cargoType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t("GlobalSetObj.all"),
                                          value: null,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t("placeOrder.Normal"),
                                          value: 0,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "3",
                                        attrs: {
                                          label: _vm.$t("GlobalSetObj.big01"),
                                          value: 1,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.search },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh", size: "small" },
                            on: { click: _vm.onReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb10" },
            [
              _c(
                "el-popover",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:etc-bulkDownload",
                      expression: "'btn:invoiceCenter:etc-bulkDownload'",
                      arg: "remove",
                    },
                  ],
                  attrs: { placement: "bottom", trigger: "hover" },
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type: "primary",
                              disabled: _vm.multipleSelection.length === 0,
                            },
                            on: { click: _vm.bulkDownload },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.CheckDownload"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.orderNumberDownload },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.DownloadByNumber"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type: "primary",
                              disabled: _vm.multipleSelection.length === 0,
                            },
                            on: { click: _vm.checkBulkDownloadXML },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.CheckDownloadXML"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { slot: "reference", size: "small" },
                      slot: "reference",
                    },
                    [_vm._v(_vm._s(_vm.$t("orderCenterCont.BulkDownload")))]
                  ),
                ],
                1
              ),
              _c(
                "el-popover",
                { attrs: { placement: "bottom", trigger: "hover" } },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value: "btn:invoiceCenter:etc-onExport",
                              expression: "'btn:invoiceCenter:etc-onExport'",
                              arg: "remove",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.onExport },
                        },
                        [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.openExportByCustomer },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("mdfeTranslate.ExportByCustomer"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value: "btn:invoiceCenter:etc-NFSeInvoiceExport",
                              expression:
                                "'btn:invoiceCenter:etc-NFSeInvoiceExport'",
                              arg: "remove",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.exportNFSeInvoice },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("mdfeTranslate.ExportNFSeInvoice"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "btn:invoiceCenter:etc-onExportOrderNumber",
                              expression:
                                "'btn:invoiceCenter:etc-onExportOrderNumber'",
                              arg: "remove",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: _vm.onExportusinessOrderNumberInvoiceNumber,
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "mdfeTranslate.ExportByInvoiceKeyOrBusinessOrderNumber"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { slot: "reference", size: "small" },
                      slot: "reference",
                    },
                    [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")))]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:etc-reopenCteInvoiceShow",
                      expression:
                        "'btn:invoiceCenter:etc-reopenCteInvoiceShow'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.reopenCteInvoiceShow },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("mdfeTranslate.ReopenCteInvoice")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:etc-cancelInvoice",
                      expression: "'btn:invoiceCenter:etc-cancelInvoice'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled:
                      _vm.multipleSelection.length === 0 ||
                      _vm.multipleSelection.length > 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openCancelInvoiceWindow(1)
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("GlobalSetObj.CancelTheInvoice")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:etc-batchCancelInvoice",
                      expression: "'btn:invoiceCenter:etc-batchCancelInvoice'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openCancelInvoiceWindow(2)
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("mdfeTranslate.BatchCancelInvoice")) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:etc-newCteInvoiceShow",
                      expression: "'btn:invoiceCenter:etc-newCteInvoiceShow'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.newCteInvoiceShow },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("mdfeTranslate.NewCteInvoice")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                color: "#f59a23",
                "font-size": "15px",
                display: "flex",
                "align-content": "center",
              },
            },
            [
              _c("span", {
                staticClass: "el-icon-warning",
                staticStyle: {
                  "font-size": "20px",
                  color: "#f59a23",
                  transform: "rotate(180deg)",
                },
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("collectionCenter.noOrdersFoundPleaseTry")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#409eff",
                    cursor: "pointer",
                    "margin-left": "20px",
                  },
                  on: { click: _vm.goToArchivedOrderQuery },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("collectionCenter.archivedDataQuery")) + " >>"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceDate",
                  label: _vm.$t("GlobalSetObj.InvoicingTime"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessTypeName",
                  label: _vm.$t("collectionCenter.businessT"),
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceNumber",
                  label: _vm.$t("basicData.InvoiceNumber"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-end",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.invoiceNumber)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("orderDetails.copy")))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#00A551",
                                  cursor: "pointer",
                                },
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    return _vm.checkDetail(scope.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.invoiceNumber))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceKey",
                  label: _vm.$t("newOrder.InvoiceKey"),
                  "min-width": "380",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-end",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.invoiceKey)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("orderDetails.copy")))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#00A551",
                                  cursor: "pointer",
                                },
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadXml(scope.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.invoiceKey))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessNumber",
                  label: _vm.$t("receivablePayable.TicketNumber"),
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "waybillNumber",
                  label: _vm.$t("GlobalSetObj.waybillNumber"),
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payerName",
                  label: _vm.$t("basicData.BillingBody"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payerTaxId",
                  label: _vm.$t("basicData.BillingBody") + "CNPJ",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: _vm.$t("GlobalSetObj.status"),
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceTotalAmount",
                  label: _vm.$t("receivablePayable.totalInvoiceAmount"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(scope.row.invoiceTotalAmount)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "icmsAmount",
                  label: _vm.$t("receivablePayable.ICMSAmount"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatNumber(scope.row.icmsAmount))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "freightAmount",
                  label: _vm.$t("mdfeTranslate.FreightAmountNoTax"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatNumber(scope.row.freightAmount))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "freightAmountInclTax",
                  label: _vm.$t("mdfeTranslate.FreightAmountTax"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(scope.row.freightAmountInclTax)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adValoremTax",
                  label: _vm.$t("basicData.AdValoremTax"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatNumber(scope.row.adValoremTax))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "insuranceFee",
                  label: _vm.$t("basicData.insurance"),
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatNumber(scope.row.insuranceFee))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: _vm.$t("basicData.CustomerName"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "averbNumber",
                  label: _vm.$t("mdfeTranslate.PolicyBatchNumber"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "allMdfeKey",
                  label: _vm.$t("mdfeTranslate.mdfeBindingRecord"),
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.allMdfeKey && scope.row.allMdfeKey.length > 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" },
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "content" },
                                  _vm._l(scope.row.allMdfeKey, function (item) {
                                    return _c("div", { key: item }, [
                                      _vm._v(_vm._s(item)),
                                    ])
                                  }),
                                  0
                                ),
                                _c("div", { staticClass: "ellipsis" }, [
                                  _vm._v(
                                    _vm._s(scope.row.allMdfeKey.join(","))
                                  ),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTable,
                  "size-change": _vm.getSizeTable,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.BatchCTEPDF"),
            visible: _vm.showDownloadCtePDF,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadCtePDF = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("ctePDF", {
                key: _vm.downloadCteXMLKey,
                attrs: {
                  "cte-data": _vm.cteData,
                  "create-pdf-type": _vm.createPdfType,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadCtePDF = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ExportusinessOrderNumberInvoiceNumberCmp", {
        ref: "exportusinessOrderNumberInvoiceNumberRef",
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.cteReopen"),
            visible: _vm.showReopenCteInvoiceWindow,
            width: "700px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showReopenCteInvoiceWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("reopenCteInvoice", {
                key: _vm.reopenCteInvoiceKey,
                ref: "reopenCteInvoiceData",
                attrs: { "multiple-selection": _vm.multipleSelection },
                on: { closeWindow: _vm.closeWindow },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showReopenCteInvoiceWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmSaveData },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("GlobalSetObj.CancelTheInvoice"),
            visible: _vm.showSingleCancelInvoice,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSingleCancelInvoice = $event
            },
            close: _vm.closeSingleCancelInvoice,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "cancelInvoiceForm",
                  attrs: {
                    model: _vm.cancelInvoiceForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("mdfeTranslate.PackageNumber") + "：",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.cancelInvoiceForm.packageNo)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("mdfeTranslate.InvoiceSecretKey") +
                                  "：",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.cancelInvoiceForm.invoiceKey)
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "mdfeTranslate.CancellationReasonType"
                                  ) + "：",
                                prop: "cancelReasonType",
                                rules: {
                                  required: true,
                                  message: _vm.$t("GlobalSetObj.pleaseChoose"),
                                  trigger: "blur",
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.cancelInvoiceForm.cancelReasonType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.cancelInvoiceForm,
                                        "cancelReasonType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "cancelInvoiceForm.cancelReasonType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "0",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.BillingError"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.IncorrectRule"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("basicData.other"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeSingleCancelInvoice },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmSingleCancelInvoice },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.BatchCancelInvoice"),
            visible: _vm.showCancelInvoiceWindow,
            width: "560px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCancelInvoiceWindow = $event
            },
          },
        },
        [
          _c("cancelInvoice", {
            key: _vm.showCancelInvoiceWindow,
            ref: "cancelInvoice",
            on: { closeCancelWindow: _vm.closeCancelWindow },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showCancelInvoiceWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmCancelInvoice },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.DownloadXml"),
            visible: _vm.showDownloadXML,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadXML = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "border-radius": "5px",
                border: "1px solid #ccc",
                padding: "10px",
                width: "100%",
                height: "500px",
                overflow: "auto",
              },
            },
            [_c("pre", [_vm._v(_vm._s(_vm.rowCteData.xmlString))])]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmDownloadXML },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadXML = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("exportNFSe", { key: _vm.showExportNFSeInvoice, ref: "exportNFSe" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.NewCteInvoice"),
            visible: _vm.showNewCteInvoiceWindow,
            width: "700px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showNewCteInvoiceWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("newCTEInvoiceIssued", {
                key: _vm.newCteInvoiceKey,
                ref: "newCteInvoiceData",
                on: { closeNewCTEWindow: _vm.closeNewCTEWindow },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showNewCteInvoiceWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmSaveNewData },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.DownloadByNumber"),
            visible: _vm.showByNumberWindow,
            width: "700px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showByNumberWindow = $event
            },
            close: _vm.closeByNumberWindow,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "downloadFormRef",
                  attrs: {
                    model: _vm.downloadForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.downloadType,
                                callback: function ($$v) {
                                  _vm.downloadType = $$v
                                },
                                expression: "downloadType",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.DownloadPdf"))
                                ),
                              ]),
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.DownloadXml"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "numberSearch",
                              attrs: { label: "" },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                      },
                                      model: {
                                        value: _vm.downloadForm.numberType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.downloadForm,
                                            "numberType",
                                            $$v
                                          )
                                        },
                                        expression: "downloadForm.numberType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "mdfeTranslate.InvoiceSecretKey"
                                          ),
                                          value: "invoiceKeyList",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "receivablePayable.TicketNumber"
                                          ),
                                          value: "businessNumberList",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "basicData.InvoiceNumber"
                                          ),
                                          value: "invoiceNumberList",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("InputTextareaCmp", {
                                ref: "byNumberRef",
                                attrs: {
                                  val: _vm.numberStr,
                                  "max-length":
                                    _vm.downloadType === 1 ? 5000 : 10000,
                                  "min-rows": 5,
                                },
                                on: {
                                  input: function (_, val) {
                                    return (_vm.numberStr = val)
                                  },
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.businessT"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.downloadForm.businessType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.downloadForm,
                                        "businessType",
                                        $$v
                                      )
                                    },
                                    expression: "downloadForm.businessType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.tudo"),
                                      value: null,
                                    },
                                  }),
                                  _vm._l(_vm.BUSINESS_TYPE, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showByNumberWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _vm.downloadType === 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.confirmDownloadFormPDF },
                    },
                    [_vm._v(_vm._s(_vm.$t("mdfeTranslate.DownloadPdf")))]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.confirmDownloadFormXML },
                    },
                    [_vm._v(_vm._s(_vm.$t("mdfeTranslate.DownloadXml")))]
                  ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.DownloadXml"),
            visible: _vm.showDownloadCteXml,
            width: "700px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadCteXml = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "20px" } },
                [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.all")) +
                        "：" +
                        _vm._s(_vm.xmlAll)
                    ),
                  ]),
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.succeed")) +
                        "：" +
                        _vm._s(_vm.xmlFilesSuccess)
                    ),
                  ]),
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.Lose")) +
                        "：" +
                        _vm._s(_vm.xmlFilesFailed)
                    ),
                  ]),
                ]
              ),
              _c("el-progress", {
                attrs: {
                  "text-inside": true,
                  "stroke-width": 20,
                  "text-color": "#fff",
                  percentage: _vm.percentage,
                },
              }),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _vm.xmlAll === _vm.xmlFilesSuccess
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("mdfeTranslate.ExportSuccessful")) +
                          _vm._s(_vm.xmlFilesSuccess) +
                          " " +
                          _vm._s(_vm.$t("mdfeTranslate.XMLs")) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.xmlFilesSuccess > 0 && _vm.xmlFilesSuccess < _vm.xmlAll
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("mdfeTranslate.ExportedXML")) +
                          " " +
                          _vm._s(_vm.xmlFilesSuccess) +
                          " " +
                          _vm._s(_vm.$t("mdfeTranslate.XMLs")) +
                          "， " +
                          _vm._s(_vm.xmlFilesFailed) +
                          " " +
                          _vm._s(_vm.$t("mdfeTranslate.NoXMLFound")) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.xmlFilesFailed === _vm.xmlAll
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("mdfeTranslate.inputWaybillNoAvailableXML")
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeDownloadCteXml },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("exportByCustomer", {
        attrs: { "show-export-by-customer": _vm.showExportByCustomer },
        on: { closeWindow: _vm.closeCustomerWindow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }